import { render, staticRenderFns } from "./ageChart.vue?vue&type=template&id=05430251&"
import script from "./ageChart.vue?vue&type=script&lang=js&"
export * from "./ageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports